import { useTranslation } from "react-i18next";
import { Alert, AlertTitle } from "@mui/material";

export const CustomAlert = (): JSX.Element => {
  const { t } = useTranslation(["form"]);

  return <Alert severity="info">{t("brandasset-picker.alert-info")}</Alert>;
};
